export const SET_COLUMN_STATE = "state/agGrid/SET_COLUMN_STATE";
export const SET_FILTER_STATE = "state/agGrid/SET_FILTER_STATE";
